import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CommandMessage } from '@nimbus-assistant/models/web-view-messages/command-message';

// Extracted from MessageService so TriggerService (and others) can react to command completions
// without depending on the whole MessageService and its dependencies.
@Injectable({ providedIn: 'root' })
export class CommandBusService {
  public readonly commandCompleted$ = new Subject<CommandMessage>();
}
